import * as React from "react";
import { hideOthers } from "aria-hidden";
import { maybeToArray, isNotNull } from "../utils";
export function useAriaHidden(enabled, elements) {
    React.useEffect(function () {
        var items = maybeToArray(elements).filter(isNotNull);
        if (enabled && items.length > 0) {
            var undo_1 = hideOthers(items);
            return function () { return undo_1(); };
        }
    }, [enabled, elements]);
}
//# sourceMappingURL=useAriaHidden.js.map